import { useState, useContext } from "react";
import { LanguageContext } from "../../../constant/LanguageContext";
import { apiFetch } from "../../../context/AuthContext";
import { translations } from "../constants/translations";
import { getTrimmedCompanyContext } from "../utils/encodeUtils";

const API_BASE_URL = `${process.env.REACT_APP_BASE_URL}/api`;

export const useAssignEmployees = (selectedCompany, onSuccess, onError, onRefresh) => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  const [selectedLevel,   setSelectedLevel]   = useState(null);
  const [candidates,      setCandidates]       = useState([]);
  const [selectedUserIds, setSelectedUserIds]  = useState([]);
  const [search,          setSearch]           = useState("");
  const [loading,         setLoading]          = useState(false);

  const open = async (level) => {
    if (!level?.id) return;
    if (!selectedCompany.client || !selectedCompany.company) {
      onError?.("Please select a client and working company first");
      return;
    }
    setSelectedLevel(level);
    setSearch("");
    setLoading(true);
    try {
      const { client, company } = getTrimmedCompanyContext(selectedCompany.client, selectedCompany.company);
      const query = new URLSearchParams({ clientName: client, workingCompany: company }).toString();
      const res   = await apiFetch(`${API_BASE_URL}/admin-levels/visibility/options/users?${query}`, { method: "GET" });
      const data  = await res.json();
      setCandidates(data?.users || []);
      setSelectedUserIds(Array.isArray(level?.users) ? level.users.map((u) => u.id) : []);
    } catch (err) {
      onError?.(err.message || "Failed to load users");
      setCandidates([]);
      setSelectedUserIds([]);
    } finally {
      setLoading(false);
    }
  };

  const toggleUser = (userId) => {
    setSelectedUserIds((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const save = async () => {
    if (!selectedLevel?.id) return;
    setLoading(true);
    try {
      await apiFetch(`${API_BASE_URL}/admin-levels/${selectedLevel.id}/assign-bulk`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userIds: selectedUserIds }),
      });
      onSuccess?.(t.assignmentsSaved);
      onRefresh?.();
      return true;
    } catch (err) {
      onError?.(err.message || "Failed to assign users");
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    selectedLevel, setSelectedLevel, candidates,
    selectedUserIds, search, setSearch, loading,
    open, toggleUser, save,
  };
};